// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */

import { AxiosError } from 'axios';
import { ofType } from 'redux-observable';
import { Observable } from 'rxjs';
import { concatMap } from 'rxjs/operators';
import { ActionType, getType } from 'typesafe-actions';

import { sendVisitedLab } from '../../apis/lab';
import { RootAction, actionCreatorsList } from '../rootActionCreator';
const { sendVisitedLabActions } = actionCreatorsList;

const outputActions = {
  success: sendVisitedLabActions.success,
  failure: sendVisitedLabActions.failure
};

type RequestActionTypes = ActionType<
  typeof sendVisitedLabActions.request
>;
type OutputActionTypes = ActionType<typeof outputActions>;

const sendVisitedLabEpic = (
  action$: Observable<RootAction>
): Observable<OutputActionTypes> => {
  return action$.pipe(
    ofType(
      // action filter
      getType(sendVisitedLabActions.request)
    ),
    concatMap((action: RequestActionTypes) => {
      // prepare api params
      const { id } = action.payload;
      // send api promise
      return sendVisitedLab(id)
        .then(response => {
          return sendVisitedLabActions.success({});
        })
        .catch((error: AxiosError) => {
          // handle error case here
          console.log(error)
          return sendVisitedLabActions.failure({ error });
        });
    })
  );
};

export { sendVisitedLabEpic as default};
